export default {"src":"/_next/static/media/search-no-results.91c20b57.svg","height":89,"width":88,"blurWidth":0,"blurHeight":0};